import { Button, Modal } from 'react-bootstrap';
import { WorkflowStatusActionType } from "@nkr/enums/index";

interface IProps {
    show: boolean,
    statusName: string,
    statusId: number,
    actionType: WorkflowStatusActionType,
    onUpdate: (actionType: WorkflowStatusActionType) => void,
    onClose: () => void
}

const StatusDeleteModal = (props: IProps) => {
    let title = null;
    let desc = '';
    let actionType = '';

    switch (props.actionType) {
        case WorkflowStatusActionType.DispositionUpdate:
        case WorkflowStatusActionType.followUpUpdate:
        case WorkflowStatusActionType.isInEmrUpdate:
        case WorkflowStatusActionType.isRuledOutUpdate:
        case WorkflowStatusActionType.isILDAUpdate:
        case WorkflowStatusActionType.sortOrderUpdate:
            //0 is update
            title = <>Update Status '{props.statusName}'</>;
            desc = 'Updating a status does not retroactively update previous donors set with this status.  Would you like to continue?';
            actionType = 'Update';
            break;

        case WorkflowStatusActionType.Delete:
            //1 delete
            title = <>Delete Status '{props.statusName}'</>;
            desc = 'Deleting a status does not retroactively update previous donors set with this status.  Would you like to continue?';
            actionType = 'Delete'
            break;

        default:
            break;
    }

    return (
        <>
            <Modal backdrop='staticd' show={props.show} onHide={props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {desc}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={() => props.onUpdate(props.actionType)}>Confirm {actionType}</Button>
                    <Button onClick={props.onClose}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default StatusDeleteModal;